import { MepChartColors } from "../../../../../constants/mep/mep.constants";
import * as Enumerable from "linq";


export interface ChartLegendItem {
    id: number;
    name: string;
    color: string;
}

export class ChartLegendViewModel {
    legendItems: ChartLegendItem[];

    constructor() { }

    generateLegendItems(data: { id: number, name: string }[]) {
        this.legendItems = [];
        data.forEach(x => {
            const typeIndex = data.findIndex(y => y == x);
            const colorIndex = typeIndex % MepChartColors.length;
            const color = MepChartColors[colorIndex] ? MepChartColors[colorIndex] : MepChartColors[0];
            const legendItem = { id: x.id, color: color, name: x.name };
            this.legendItems.push(legendItem);
        });
    }

    getColor(legendId: number): string {
        return Enumerable.from(this.legendItems).where(x => x.id == legendId).select(x => x.color).firstOrDefault()
    }
}
